<template>
    <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        max-width="90vw"
        persistent
        style="overflow:hidden"
    >   
            <v-card v-if="dialog" height="90vh">
                <v-toolbar dark color="primary" height="48">
                    <span v-if="totalPages" class="text-caption">{{  totalPages }} page(s)</span>
                    <v-spacer></v-spacer>
                    <v-btn icon small dark :disabled="zoom <= 0.5" @click="zoomOut">
                    <v-icon>mdi-magnify-minus-outline</v-icon>
                    </v-btn>
                    <span class="text-caption mx-1">{{ Math.round(zoom * 100) }}%</span>
                    <v-btn icon small dark :disabled="zoom >= 3" @click="zoomIn">
                        <v-icon>mdi-magnify-plus-outline</v-icon>
                    </v-btn>
                    <v-btn icon small dark @click="resetZoom">
                        <v-icon>mdi-magnify-scan</v-icon>
                    </v-btn>
                    <v-btn v-if="downloadForm" class="mr-3" icon small dark :disabled="!src" @click="downloadPdf">
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-btn  icon small dark @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <div class="pdf-scroll-container">
                    
                    <div v-if="loading">
                        <span class="loader">Load ng</span>
                    </div>

                    <vue-pdf-embed 
                        v-if="src"
                        ref="pdfEmbed"
                        :source="src"
                        :width="renderWidth"
                        @loaded="onLoaded"
                        @rendered="onRendered"
                    />
                </div>
        </v-card>                       
    </v-dialog>   
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed.js';
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: 'PDFViewer',

    components: {
        VuePdfEmbed
    },

    props:{
        url: String,
        fileSrc: String,
        initialDialog: {
            type: Boolean,
            default: false
        },
        reportName: String,
        downloadForm: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapGetters({
            authToken: 'auth/getAuthToken',
        }),
        

        renderWidth(){
            return Math.round(this.baseWidth * this.zoom);
        },
    },

    watch: {
        initialDialog : {
            handler (val) {
                if(val) this.displayReport();
            },
        },
    },

    data: function(){
        return {
            dialog: this.initialDialog,
            totalPages: 0,
            loading: false,
            zoom: 1,
            baseWidth: 350, 
            src: null,
        }
    },

    methods: {
        displayReport(){
            this.loading = true;
            this.zoom = 1;
            this.dialog = true;
            
            this.baseWidth = Math.min(window.innerWidth - 32, 700);
            if(this.url){
                this.src = this.url;
                return;
            }
            
            if(this.fileSrc){
                axios.get(
                    this.fileSrc,
                    {
                        responseType: 'arraybuffer',
                        headers: {
                            Authorization: 'Bearer ' + this.authToken,
                            Accept: 'application/pdf'
                        }
                    }
                )
                .then(response => {
                    this.src = new Uint8Array(response.data);
                })
                .catch(error => {
                    console.log('Failed to load report card: ', error);
                    this.loading = false;
                })
            }
        },

        onLoaded(pdf){
            this.totalPages = pdf.numPages;
        },

        onRendered(){
            this.loading = false;
        },

        zoomIn() {
            this.zoom = Math.min(3, +(this.zoom + 0.25).toFixed(2));
        },

        zoomOut() {
            this.zoom = Math.max(0.5, +(this.zoom - 0.25).toFixed(2));
        },

        resetZoom() {
            this.zoom = 1;
        },

        downloadPdf() {
            if (!this.src) return;

            const blob = new Blob([this.src], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.reportName}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Free the memory once the browser's captured the download
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        },
        close(){
            this.dialog = false;
            this.src = null;
            this.$emit('closeDialog');
        },
    }
}

</script>

<style scoped>
    ::v-deep .v-dialog--fullscreen > .v-card{
        min-height: 0;
    }

    ::v-deep .v-dialog--fullscreen > .v-card{
        min-height: 0;
    }

    .pdf-scroll-container {
        /* height: calc(100vh - 28px); */
        height: 80vh;
        overflow-y: auto;
        background: #525659;
        padding: 16px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    /* vue-pdf-embed renders each page as its own <div>/<canvas>;
    space them out and give a subtle page-edge shadow */
    .pdf-scroll-container ::v-deep .vue-pdf-embed > div {
        margin-bottom: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    .pdf-scroll-container ::v-deep canvas {
        max-width: 100%;
        height: auto !important;
    }

    /* @content: "Load ng" */

.loader {
  --color-1: #fff;
  --size: 0.8px;

  color: var(--color-1);
  position: relative;
  display: inline-block;
  margin-top: calc(40 * var(--size));
  font-family: Arial, Helvetica, sans-serif;
  font-size: calc(48 * var(--size));
  letter-spacing: calc(4 * var(--size));
  box-sizing: border-box;
}
.loader::before {
  content: '';
  position: absolute;
  right: calc(69 * var(--size));
  bottom: calc(20 * var(--size));
  height: calc(26 * var(--size));
  width: calc(4 * var(--size));
  background: currentColor;
  box-sizing: border-box;
  animation: animloader1 1s linear infinite alternate;
}
.loader::after {
  content: '';
  width: calc(10 * var(--size));
  height: calc(10 * var(--size));
  position: absolute;
  left: calc(125 * var(--size));
  top: calc(2 * var(--size));
  border-radius: 50%;
  background: red;
  box-sizing: border-box;
  animation: animloader 1s linear infinite alternate;
}

@keyframes animloader {
  0% {
    transform: translate(0, 0) scaleX(1);
  }
  14% {
    transform: translate(calc(-12 * var(--size)), calc(-16 * var(--size))) scaleX(1.05);
  }
  28% {
    transform: translate(calc(-27 * var(--size)), calc(-28 * var(--size))) scaleX(1.07);
  }
  42% {
    transform: translate(calc(-46 * var(--size)), calc(-35 * var(--size))) scaleX(1.1);
  }
  57% {
    transform: translate(calc(-70 * var(--size)), calc(-37 * var(--size))) scaleX(1.1);
  }
  71% {
    transform: translate(calc(-94 * var(--size)), calc(-32 * var(--size))) scaleX(1.07);
  }
  85% {
    transform: translate(calc(-111 * var(--size)), calc(-22 * var(--size))) scaleX(1.05);
  }
  100% {
    transform: translate(calc(-125 * var(--size)), calc(-9 * var(--size))) scaleX(1);
  }
}

@keyframes animloader1 {
  0% {
    box-shadow:
      0 calc(-16 * var(--size)),
      calc(-124.5 * var(--size)) calc(-8 * var(--size));
  }
  25%,
  75% {
    box-shadow:
      0 0,
      calc(-124.5 * var(--size)) calc(-8 * var(--size));
  }
  100% {
    box-shadow:
      0 0,
      calc(-124.5 * var(--size)) calc(-24 * var(--size));
  }
}


</style>